// src/modules/app-views/welcome/pages/Init/modals/FirstSubscriptionModal/StepAiContext.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Alert } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import AiBusinessContextCard from 'modules/app-views/account/pages/Subscription/tabs/RecordTab/AiBusinessContextCard';
import translateX from 'utils/translateX';

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const StepAiContextContent = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div style={{ paddingTop: 8 }}>
      {/* Info message */}
      {/*<Alert*/}
      {/*  type="info"*/}
      {/*  showIcon*/}
      {/*  icon={<RobotOutlined />}*/}
      {/*  style={{ marginBottom: 16 }}*/}
      {/*  title={translateX('ai_context')}*/}
      {/*  description={translateX('ai_business_context_description')}*/}
      {/*/>*/}

      {/* AI context field */}
      <AiBusinessContextCard required forceDisabled={false} />
    </div>
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const stepAiContext = () => ({
  stepTitle: 'ai_context',
  stepTooltip: 'enter_ai_business_context',
  content: () => <StepAiContextContent />,
  validationFields: ['aiBusinessContext'],
  onEnter: ({ goFocus }) => {
    setTimeout(() => {
      goFocus?.('aiBusinessContext');
    }, 100);
  },
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default stepAiContext;
